import { select, selectAll } from 'd3-selection';
import { createModalLaunchButton } from './abstract-dialog.mjs';
import { _cloneTemplate } from './utils.mjs';



function insertLink(container, url) {
  const a = container.append('a');
  a.attr('href', url);
  a.attr('target', '_blank')
  return a;
}

function insertSpan(container) {
  const span = container.append('span');
  return span;
}


function insertSocialIcon(container, { label, icon, link }) {
  const li = container.append('li');
  
  const a = li.append('a')
    .attr('href', link)
    .attr('aria-label', label);

  a.append('i')
    .attr('class', icon)
    .attr('aria-hidden', true);

  return li;
}


function addSpeakerList(talks) {
  const speakerData = Array.from(talks.values())
    .filter(t => t.type === 'main')
    .flatMap(t => t.speakers)
    .sort((a, b) => a.alpha.localeCompare(b.alpha));

  if (!speakerData.length) {
    selectAll('#talks, #main-speakers').remove();
    return;
  }

  const template = select('#main-speaker-template');
  const cloneTemplate = _cloneTemplate.bind(template);
  const container = select('#main-speakers');

  const speakers = container.select('ul')
    .selectAll('li.speaker')
    .data(speakerData)
    .enter()
    .append('li')
    .attr('id', d => `${d.id}`)
    .attr('class', 'speaker');

  speakers.each(function(d) {
    const talk = talks.get(d.talkId);
    const entry = cloneTemplate(select(this));

    const headshot = entry.select('.speaker-headshot');
    headshot.attr('src', d.img.src);
    headshot.attr('srcset', d.img.srcset);
    headshot.attr('alt', d.img.alt);
    
    entry.select('.speaker-name').text(d.name);

    const powDiv = entry.select('.speaker-pow');
    if (d.pow) {
      const pow = d.link ? insertLink(powDiv, d.link) : insertSpan(powDiv); 
      pow.text(d.pow);
    }
    else { powDiv.remove(); }

    const socialList = entry.select('.speaker-social-icons');
    if (!d.social) { socialList.remove(); }
    else {
      d.social.forEach(function(social) {
        insertSocialIcon(socialList, social);
      });
    }

    const title = entry.select('.speaker-title')
    if (talk.title) {
      title.append('span').text(talk.title);
    }
    else {
      title.append('em').text('Title TBC');
    }
    
    const cospeakers = talk.speakers.filter(s => s !== d);
    
    if (cospeakers.length) {
      const span = title.append('span');
      const em = span.append('em');
      em.append('span').text(' (with ');

      cospeakers.forEach(function(d, i, arr) {
        em.append('a').attr('href', `#${d.id}`).text(d.name);
        const remain = arr.length - (i + 1);
        if (remain) { em.append('span').text(remain === 1 ? ' and ' : ', '); }
      });

      em.append('span').text(')');
    }

    if (talk.abstract) {
      createModalLaunchButton(title, talk.id);
    }
  });
}


export { addSpeakerList };
